import Typography from '../typography/typography';

export const Typographies = () => (
  <>
    <Typography variant="display1">Display1</Typography>
    <Typography variant="display2">Display2</Typography>
    <Typography variant="heading1">Heading1</Typography>
    <Typography variant="heading2">Heading2</Typography>
    <Typography variant="heading3">Heading3</Typography>
    <Typography variant="heading4">Heading4</Typography>
    <Typography variant="heading5">Heading5</Typography>
    <Typography variant="body1">Body1</Typography>
    <Typography variant="body2">Body2</Typography>
    <Typography variant="body3">Body3</Typography>
    <Typography variant="body4">Body4</Typography>
  </>
);
